import { defineStore } from 'pinia';

export const useLandingSportsStore = defineStore('landingSportsStore', {
	state: () => ({
		selected_overview_market: null,
		selected_sport: null,
	}),
	getters: {
		getSelectedOverviewMarket(state) {
			return state.selected_overview_market
		},
		getSelectedSport(state) {
			return state.selected_sport;
		},
	},
	actions: {
		setSelectedOverviewMarket(data) {
			this.selected_overview_market = data;
		},
		setSelectedSport(data) {
			this.selected_sport = data;
		}
	}
})